<template>
  <footer class="footer">
    <div class="container">
      <nav>
        <ul>
          <li>
            <a href="https://prodigy-store.onrender.com/">Prodigy Store</a>
          </li>
          <li>
            <a href="https://github.com/prodigy-RBK/dashboard">
              Github Repo
            </a>
          </li>
        </ul>
      </nav>
      <div class="copyright text-center">
        &copy; {{ new Date().getFullYear() }} <a href="https://prodigy-store.onrender.com/" target="_blank">Prodigy Store</a>, made with
        <i class="fa fa-heart heart"></i> for a better web
      </div>
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style></style>
